// extracted by mini-css-extract-plugin
module.exports = {"linkNormal":"MenuLink-module--link-normal--2yXJt","linkSecret":"MenuLink-module--link-secret--3xSAK"};